import { useEffect } from "react";
import CatalogView from "@/components/feature/CatalogView";

const TITLE = "电影频道 - 白虎影视平台";
const DESCRIPTION =
  "浏览白虎精选电影资源，支持类型、地区、年份筛选，查看热门电影海报、评分与上映年份。";

export default function Movies() {
  useEffect(() => {
    document.title = TITLE;
    const meta = document.querySelector('meta[name="description"]');
    if (meta) {
      meta.setAttribute("content", DESCRIPTION);
    }
  }, []);

  return (
    <CatalogView
      category="movie"
      title="电影频道"
      breadcrumb="电影频道"
      description="浏览白虎精选电影资源，支持类型、地区、年份筛选与排序，快速定位你感兴趣的作品。点击卡片即可查看完整剧情介绍与主创信息。"
    />
  );
}